import { render, staticRenderFns } from "./LogisticCostDialog.vue?vue&type=template&id=38ad8336&scoped=true"
import script from "./LogisticCostDialog.vue?vue&type=script&lang=js"
export * from "./LogisticCostDialog.vue?vue&type=script&lang=js"
import style0 from "./LogisticCostDialog.vue?vue&type=style&index=0&id=38ad8336&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ad8336",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38ad8336')) {
      api.createRecord('38ad8336', component.options)
    } else {
      api.reload('38ad8336', component.options)
    }
    module.hot.accept("./LogisticCostDialog.vue?vue&type=template&id=38ad8336&scoped=true", function () {
      api.rerender('38ad8336', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shipping/LogisticCostDialog.vue"
export default component.exports